import PropTypes from "prop-types";
import { productShape } from "app/utils/propTypes";
import { MerchandisingCard } from "../merchandising/MerchandisingCard";
import ProductCard from "@brand/Product/default/Product";
import { LISTING_ITEM_TYPES } from "app/constants";

const ListingItemCard = ({ product = {}, resolution, hideMerchandising, showSmartDPOnRootUrl }) => {
	if (product.type === LISTING_ITEM_TYPES.PRODUCT) {
		return (
			<ProductCard
				resolution={resolution}
				product={product}
				showSmartDPOnRootUrl={showSmartDPOnRootUrl}
			/>
		);
	} else if (!hideMerchandising) {
		return <MerchandisingCard product={product} resolution={resolution} />;
	}
	return false;
};

ListingItemCard.propTypes = {
	product: productShape,
	resolution: PropTypes.string,
	hideMerchandising: PropTypes.bool,
	showSmartDPOnRootUrl: PropTypes.bool,
};

export default ListingItemCard;
